import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { FieldValidationType } from '../../../../sic-lib/enums/FieldValidationType';
import { ContactField } from '../../../../sic-lib/types/ContactField';
import {
    hasMatchingFieldId,
    hasMatchingValidationType,
} from '../../../../sic-lib/utils/functionalFilters';
import DisplayPhoneNumber from '../../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';

const useStyles = makeStyles()((theme: Theme) => ({
    item: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
            '&:hover': {
                backgroundColor: theme.palette.menuListHover.main,
            },
        },
    },
}));

interface Props {
    menuId: string;
    anchorEl: HTMLElement | null;
    selectedFieldId: number;
    options: ContactField<string>[];
    onSelectHandler: React.Dispatch<{
        fieldId: number;
        fieldValue: string;
        fieldLabel: string;
    }>;
    onCloseHandler: () => void;
}

export default function MenuSetChannelValueRaw({
    menuId,
    anchorEl,
    selectedFieldId,
    options,
    onSelectHandler,
    onCloseHandler,
}: Props) {
    const { classes } = useStyles();

    const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
        const { fieldId } = event.currentTarget.dataset;

        if (fieldId) {
            const matchedField = options.filter(hasMatchingFieldId(+fieldId))[0];

            if (matchedField) {
                onSelectHandler({
                    fieldId: matchedField.fieldId,
                    fieldValue: matchedField.value as string,
                    fieldLabel: matchedField.label,
                });

                onCloseHandler();
            }
        }
    };

    return (
        <Menu
            id={menuId}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onCloseHandler}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            {options.map(itm => (
                <MenuItem
                    key={itm.fieldId}
                    data-field-id={itm.fieldId}
                    selected={itm.fieldId === selectedFieldId}
                    onClick={handleSelect}
                    className={classes.item}
                >
                    <ListItemText
                        primary={itm.label}
                        secondary={
                            hasMatchingValidationType(FieldValidationType.usMobilePhone)(itm) ? (
                                <DisplayPhoneNumber phoneNumber={itm.value} />
                            ) : (
                                itm.value
                            )
                        }
                    />
                </MenuItem>
            ))}
        </Menu>
    );
}
